import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

import { AccessExplainerObjectDetails, AccessType } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAccessComparisonByObjectIdRequest = DynamicQueryParams & {
	objectId: string;
	accessId: Array<string>;
	accessType: Array<AccessType>;
};

export type GetDataSecurityAccessComparisonByObjectIdResponse = AccessExplainerObjectDetails;

export const getDataSecurityAccessComparisonByObjectId =
	createGetEndpoint<
		GetDataSecurityAccessComparisonByObjectIdRequest,
		GetDataSecurityAccessComparisonByObjectIdResponse
	>(
		({ objectId, ...rest }) => `/api/v3/salesforce/data-access/compare/object/${objectId}?${getQueryString(rest)}`
	);
